module.exports = __webpack_public_path__ + "img/1.3dc0c360.png";